/* eslint-disable @reatom/unit-naming-rule */
import { tradingPairAddressAtom } from '@root/features/trade/trading/atoms'

import { reatomControlsCommon } from '../reatom-controls-common'

import { reatomLimitBuyControls } from './reatom-limit-buy-controls'
import { reatomMarketBuyControls } from './reatom-market-buy-controls'

export const reatomBuyControls = () => {
  const marketModel = reatomMarketBuyControls()

  const limitModel = reatomLimitBuyControls({
    buyAmountNativeAtom: marketModel.amountInputModel.amountAtom,
  })

  reatomControlsCommon({
    pairAddressAtom: tradingPairAddressAtom,
    quoteModel: marketModel.quoteModel,
  })

  return {
    ...marketModel,
    limitModel,
  }
}
export type BuyControlsModel = ReturnType<typeof reatomBuyControls>
